import Axe from './core/axe.js';
let axejs = new Axe();
module.exports = global.axejs = axejs;
